// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-3vgvE";
var _4 = "cards-2pTeA";
var _5 = "title-3zCkM";
var _6 = "baggage__dialogContent-3FG-4";
var _7 = "baggagePage__baggage-2MXxM";
var _8 = "meal__dialogContent-2KO4S";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "cards", _5 as "title", _6 as "baggage__dialogContent", _7 as "baggagePage__baggage", _8 as "meal__dialogContent" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "cards": _4, "title": _5, "baggage__dialogContent": _6, "baggagePage__baggage": _7, "meal__dialogContent": _8 }
